import { Network } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import './styles.scss';

interface ITableContractField {
  address: string;
  chain: string;
  textSize?: number;
}

const TableContractField = ({
  address,
  chain,
  textSize = 12,
}: ITableContractField) => {
  const network = Network.fromChain(chain);
  const fmt = `${address.slice(0, 6)}...${address.slice(address.length - 4)}`;

  const onCopy = (e: any) => {
    e.preventDefault();
    navigator.clipboard
      .writeText(address)
      .then(() => {
        console.log('Copied to clipboard');
      })
      .catch((err) => {
        console.warn('Could not copy to clipboard', err);
      });
  };
  const onScan = (e: any) => {
    e.preventDefault();
    const link = network?.getScanForToken(address) || '';
    window.open(link);
  };
  return (
    <div className='contract__cell'>
      <Text size={textSize} className='text--navy-700'>
        {fmt}
      </Text>
      <div className='contract__cell__icon icon-copy' onClick={onCopy} />
      <div
        className='contract__cell__icon icon-top-right-square'
        onClick={onScan}
      />
    </div>
  );
};

export default TableContractField;
